
import { supabase } from "@/integrations/supabase/client";
import { completeGame, divergeGame } from "@/utils/gameCommands";

/**
 * Handle when words match (game convergence)
 */
export const handleWordMatch = async (
  gameId: string,
  roundNumber: number,
  finalWord: string,
  setGameOver: (gameOver: boolean) => void,
  setConvergenceRound: (round: number | null) => void,
  setGameStatus: (status: string) => void
) => {
  // Update the database with the perfect proximity score
  const { error: proximityError } = await supabase
    .from("rounds")
    .update({ 
      proximity_score: 100
    })
    .eq("game_id", gameId)
    .eq("round_number", roundNumber);
    
  if (proximityError) {
    console.error("Error updating proximity score:", proximityError);
    // Non-blocking error - continue even if this fails
  }
  
  // Game over - update game status
  await completeGame(gameId, finalWord);
  setGameOver(true);
  setConvergenceRound(roundNumber);
  setGameStatus("completed");
};

/**
 * Handle when max rounds are reached (game divergence)
 */
export const handleMaxRoundsReached = async (
  gameId: string,
  setGameOver: (gameOver: boolean) => void,
  setGameStatus: (status: string) => void,
  toast: any
) => {
  console.log("Max rounds reached, marking game as diverged");
  
  try {
    const result = await divergeGame(gameId);
    if (result) {
      setGameOver(true);
      setGameStatus("diverged");
    } else {
      throw new Error("Failed to mark game as diverged");
    }
  } catch (divergeError) {
    console.error("Failed to mark game as diverged:", divergeError);
    // Still set game over state even if the DB update fails
    setGameOver(true);
    setGameStatus("diverged");
    toast({
      variant: "destructive",
      title: "Error",
      description: "There was a problem updating the game status. Please refresh the page."
    });
  }
};
